import { Expose } from '../serialization/class-transformer/decorators';
import { AccessMode } from './access-mode.enum';

export class UserMetaData {

    @Expose()
    securityAccess?: AccessMode;

}
